module.exports = "/legacy/1e4b4def5aa6798632e44ccc28ed3515.svg";